var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "metrics" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c("div", { staticClass: "dropdown d-inline" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary dropdown-toggle",
                          staticStyle: { padding: "0.7em 2em" },
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n                        Create metric\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
                          attrs: { role: "menu" },
                        },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/enterprise/create-revenue-metric/${_vm.workspaceId}/${_vm.strategyId}`,
                                  expression:
                                    "`/#/enterprise/create-revenue-metric/${workspaceId}/${strategyId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("Revenue")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/enterprise/create-margin-cogs-metric/${_vm.workspaceId}/${_vm.strategyId}`,
                                  expression:
                                    "`/#/enterprise/create-margin-cogs-metric/${workspaceId}/${strategyId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("COGS (Margin)")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/enterprise/create-resource-metric/${_vm.workspaceId}/${_vm.strategyId}`,
                                  expression:
                                    "`/#/enterprise/create-resource-metric/${workspaceId}/${strategyId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("Resource (units)")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/enterprise/create-resource-cost-metric/${_vm.workspaceId}/${_vm.strategyId}`,
                                  expression:
                                    "`/#/enterprise/create-resource-cost-metric/${workspaceId}/${strategyId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("Resource (money)")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/enterprise/create-total-cost-metric/${_vm.workspaceId}/${_vm.strategyId}`,
                                  expression:
                                    "`/#/enterprise/create-total-cost-metric/${workspaceId}/${strategyId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("Total cost")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/enterprise/create-capex-metric/${_vm.workspaceId}/${_vm.strategyId}`,
                                  expression:
                                    "`/#/enterprise/create-capex-metric/${workspaceId}/${strategyId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("Capex")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/enterprise/create-expense-metric/${_vm.workspaceId}/${_vm.strategyId}`,
                                  expression:
                                    "`/#/enterprise/create-expense-metric/${workspaceId}/${strategyId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("Expense")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/enterprise/create-cost-subtotal-metric/${_vm.workspaceId}/${_vm.strategyId}`,
                                  expression:
                                    "`/#/enterprise/create-cost-subtotal-metric/${workspaceId}/${strategyId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("Cost subtotal")]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _vm.rm
                ? _c("div", { staticClass: "d-flex flex-wrap mb-3" }, [
                    _c("div", { staticStyle: { width: "250px" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchPhrase,
                            expression: "searchPhrase",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "search",
                          placeholder: "Search by name...",
                        },
                        domProps: { value: _vm.searchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown ml-3" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          class: _vm.filterByMetricType
                            ? "btn-info"
                            : "btn-outline-secondary",
                          attrs: { type: "button", "data-toggle": "dropdown" },
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-filter mr-1",
                            class: _vm.filterByMetricType
                              ? "text-warning"
                              : "text-muted",
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Metric type")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              class: {
                                active: _vm.filterByMetricType === null,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setFilterByMetricType(null)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        Any / No filter\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("Filter by metric type"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.rm.MetricTypes, function (m) {
                            return _c(
                              "a",
                              {
                                key: m,
                                staticClass: "dropdown-item",
                                class: { active: _vm.filterByMetricType === m },
                                on: {
                                  click: function ($event) {
                                    return _vm.setFilterByMetricType(m)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(m) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.metricsView, function (m) {
                        return _c("tr", { key: m.Id }, [
                          _c("td", [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: _vm.getEditUrl(m),
                                    expression: "getEditUrl(m)",
                                  },
                                ],
                                staticClass: "text-primary",
                              },
                              [_vm._v(_vm._s(m.Name))]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(m.Description)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(m.MetricTypeLabel) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "dropdown" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Actions\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: _vm.getEditUrl(m),
                                          expression: "getEditUrl(m)",
                                        },
                                      ],
                                      staticClass: "dropdown-item",
                                    },
                                    [_vm._v("Edit")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: _vm.getCloneUrl(m),
                                          expression: "getCloneUrl(m)",
                                        },
                                      ],
                                      staticClass: "dropdown-item",
                                    },
                                    [_vm._v("Clone")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "dropdown-divider",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeleteMetricCommand(
                                            m.Id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Metrics")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Metric")]),
        _vm._v(" "),
        _c("th", [_vm._v("Type")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }